import type { RouteObject } from "react-router-dom";

import { Protected } from "@dzambalaorg/common-pages";
import {
  IndexWrapper,
  PonziSection,
  PonziChart,
  PonziContract,
  PonziReport,
  PonziRules,
  ServiceType,
} from "@framework/shared";

export const ponziRoutes: Array<RouteObject> = [
  {
    path: "/ponzi",
    children: [
      {
        index: true,
        element: (
          <IndexWrapper index="ponzi">
            <PonziSection service={ServiceType.OFFICE} />
          </IndexWrapper>
        ),
      },
      {
        path: "/ponzi/contracts",
        element: <Protected />,
        children: [
          { index: true, element: <PonziContract service={ServiceType.OFFICE} /> },
          { path: "/ponzi/contracts/:id/:action", element: <PonziContract service={ServiceType.OFFICE} /> },
        ],
      },
      {
        path: "/ponzi/rules",
        element: <Protected />,
        children: [
          { index: true, element: <PonziRules service={ServiceType.OFFICE} /> },
          { path: "/ponzi/rules/:id/:action", element: <PonziRules service={ServiceType.OFFICE} /> },
        ],
      },
      {
        path: "/ponzi/report",
        element: <Protected />,
        children: [
          { index: true, element: <PonziReport service={ServiceType.OFFICE} /> },
          { path: "/ponzi/report", element: <PonziReport service={ServiceType.OFFICE} /> },
        ],
      },
      {
        path: "/ponzi/chart",
        element: <Protected />,
        children: [
          { index: true, element: <PonziChart service={ServiceType.OFFICE} /> },
          { path: "/ponzi/chart", element: <PonziChart service={ServiceType.OFFICE} /> },
        ],
      },
    ],
  },
];
